import {AfterViewInit, Component, ElementRef, Input, OnChanges, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {Cell} from '../models';

@Component({
    selector: 'table-cell-view-mode',
    template: `
    <div>
      @switch (cell.getColumn().type) {
        @case ('html') {
          <div #cellContainer [innerHTML]="cell.getValue()"></div>
        }
        @default {
          <div #cellContainer>{{ cell.getValue() }}</div>
        }
      }
    </div>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ViewCellComponent implements OnChanges, AfterViewInit {

  @Input() cell: Cell;
  @ViewChild('cellContainer') cellRef: ElementRef;

  ngOnChanges(changes): void {
    setTimeout(() => this.renderCustomValue());
  }

  ngAfterViewInit(): void {
    this.renderCustomValue();
  }

  renderCustomValue(): void {
    const cellRenderFunc = this.cell.getColumn().getCellRenderFunction();
    if (cellRenderFunc && this.cellRef) {
      cellRenderFunc.call(null, this.cell, this.cellRef.nativeElement);
    }
  }
}
